<template>
  <b-form-group
    label="Şehir"
    label-for="id_cities"
  >
    <v-select
      v-model="dataItem.id_cities"
      :options="cities"
      label="title"
      :reduce="item => item.id"
      placeholder="Şehir"
      @input="getDistricts"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'City',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    dataItem() {
      return this.$store.getters['tenants/dataItem']
    },
    cities() {
      return this.$store.getters['cities/dataList']
    },
  },
  created() {
    this.getCities()
  },
  methods: {
    getCities() {
      this.$store.dispatch('cities/getDataList', {
        select: [
          'cities.id AS id',
          'cities.title AS title',
        ],
      })
    },
    getDistricts() {
      this.dataItem.id_districts = null
      if (this.dataItem.id_cities) {
        this.$store.dispatch('districts/getDataList', {
          select: [
            'districts.id AS id',
            'districts.title AS title',
          ],
          where: {
            'districts.id_cities': this.dataItem.id_cities,
          },
        })
      }
    },
  },
}
</script>
